import { db } from "../../../service/API";

export class ProfileFavouriteConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
    this.rightId = userData.rightId;
  }

  /**
   * DIMENSIONS HISTORY
   */
  getHistDimensions(nb = 50) {
    return new Promise((resolve, reject) => {
      db.get("/ProfileFavouriteConnector/getHistDimensions/" + this.userId + "/" + nb)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get hist dimensions failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get hist dimensions : " + err.message);
        });
    });
  }

  insertHistDimension(width, height) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileFavouriteConnector/insertHistDimension/", {
        uid: this.userId,
        width: width,
        height: height,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve();
          } else {
            return reject("insert hist dimension failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on insert hist dimension : " + err.message);
        });
    });
  }

  deleteHistDimension(width, height) {
    return new Promise((resolve, reject) => {
      db.delete("/ProfileFavouriteConnector/deleteHistDimension/", {
        uid: this.userId,
        width: width,
        height: height,
      })
        .then((response) => {
          if (response.status == 204) {
            return resolve();
          } else {
            return reject("delete hist dimension failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on delete hist dimension : " + err.message);
        });
    });
  }

  /**
   * PROJECTS HISTORY
   */
  getHistProjects(nb = 11) {
    return new Promise((resolve, reject) => {
      db.get("/ProfileFavouriteConnector/getHistProjects/" + this.userId + "/" + nb)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get hist projects failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get hist projects : " + err.message);
        });
    });
  }

  insertHistProject(pid) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileFavouriteConnector/insertHistProject/", {
        uid: this.userId,
        pid: pid,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve();
          } else {
            return reject("insert hist project failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on insert hist project : " + err.message);
        });
    });
  }

  insertHistProjectByFilepath(filepath) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileFavouriteConnector/insertHistProjectByFilepath/", {
        uid: this.userId,
        sid: this.socId,
        path: filepath,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve();
          } else {
            return reject("insert hist project with file path failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on insert hist project with file path : " + err.message);
        });
    });
  }

  deleteHistProject(pid) {
    return new Promise((resolve, reject) => {
      db.delete("/ProfileFavouriteConnector/deleteHistProject/", {
        uid: this.userId,
        pid: pid,
      })
        .then((response) => {
          if (response.status == 204) {
            return resolve();
          } else {
            return reject("delete hist project failed with status : " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on delete hist project : " + err);
        });
    });
  }
}
